import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { ORDER_BY } from './-types';
export const SearchSchema = z.object({
  // NOTE: 検索機能は不要
  // freeText: z.string().optional(),
  sortColumn: z.nativeEnum(ORDER_BY).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  pageIndex: z.number().int().nonnegative().default(0),
  pageSize: z.number().int().positive().default(100)
});